import { DIFFICULTY } from "../../../../common/constants.ts";
import i18n from "./i18n.ts";

export const translateDifficultyName = (name: string) =>
	i18n.t(`difficulty.${name.toLowerCase()}`, {
		ns: "ui",
		defaultValue: name,
	});

export const normalizeDifficulty = (difficulty: number) => {
	const values = Object.values(DIFFICULTY).filter(
		(value): value is number => typeof value === "number",
	);

	return values.reduce((best, current) =>
		Math.abs(current - difficulty) < Math.abs(best - difficulty)
			? current
			: best,
	);
};

export const difficultyText = (difficulty: number | undefined) => {
	let prevText: string | undefined;

	if (difficulty === undefined) {
		return "???";
	}

	for (const [text, numeric] of Object.entries(DIFFICULTY)) {
		if (typeof numeric !== "number") {
			throw new Error("Should never happen");
		}

		if (difficulty === numeric) {
			return translateDifficultyName(text);
		}

		// Iteration is in order, so if we're below the value, there will be no direct hit
		if (difficulty < numeric) {
			if (prevText !== undefined) {
				return `${translateDifficultyName(prevText)}+`;
			}

			return `${translateDifficultyName(text)}-`;
		}

		prevText = text;
	}

	if (prevText !== undefined) {
		return `${translateDifficultyName(prevText)}+`;
	}

	return "???";
};
